import type { VendorApplicationItem } from './adminApiClient';

export function duplicateWarningLabel(
  warning: VendorApplicationItem['duplicateBusinessWarning'],
): string | null {
  return warning ? `⚠ Possible duplicate (${warning.matchCount})` : null;
}

export function canUnlockReapplication(
  application: Pick<VendorApplicationItem, 'status' | 'reapplyUnlockedAt'>,
  hasManageCapability: boolean,
): boolean {
  return hasManageCapability
    && (application.status === 'declined' || application.status === 'withdrawn')
    && !application.reapplyUnlockedAt;
}
